import DateGlobalFilter from './DateGlobalFilter';

export default DateGlobalFilter;
